import { Component, OnInit } from '@angular/core';
import { InvestFundService } from '../invest-fund.service';
import { FundsIncome, InvestFund } from '../funds-income';
import { stringify } from 'querystring';
import { Router } from '@angular/router';

@Component({
  selector: 'app-invest-fund-suno',
  templateUrl: './invest-fund-suno.component.html',
  styleUrls: ['./invest-fund-suno.component.css'],

})
export class InvestFundSunoComponent extends FundsIncome implements OnInit {

  constructor(private service: InvestFundService, router: Router) {
    super(service, router);
  }

  ngOnInit() {
    this.currentMonth = new Date().getMonth() + 1;

    this.getAllDataFromService(this.selectedYear);
  }

  //Auxiliar methods
  private getAllDataFromService(year: string){
    this.funds.forEach(fund => {
      var cnpjUrl = this.getUrlCNPJ(fund.cnpj);
      this.service.getInvestsSuno(cnpjUrl).subscribe(data => {
        this.retrieveDataFromJson(year, data, fund.returns, fund.label);
      });
    });
  }

  private retrieveDataFromJson(year: string, jsonData: any, arrayToUpdate: string[], fundName: string){
    for (let index = 0; index < 12; index++) {
      if (index+1 < 10){
        arrayToUpdate[index] = jsonData.filter(d => d.year == year)[0]["month_0"+(index+1)].toString().slice(0,4);
      } else{
        arrayToUpdate[index] = jsonData.filter(d => d.year == year)[0]["month_"+(index+1)].toString().slice(0,4);
      }

      if (arrayToUpdate[index] == "unde")
        arrayToUpdate[index] = ""
    }
    if(year === new Date().getFullYear().toString()){
      this.updateAllFundsMonthTable(arrayToUpdate, fundName, this.currentMonth, null);
    } else{
      this.updateAllFundsMonthTable(arrayToUpdate, fundName, 12, null);
    }
  }

  onSelectedYearChange(event: any) {
    this.selectedYear = event.target.value;
    this.allFundsLastMonths = [];
    this.getAllDataFromService(this.selectedYear);

    this.fundCalcReturn = this.calculateReturns(this.selectedFund, this.selectedMonth, this.fundInvestedValue).toString();
  }

  public addNewFund() {
    var newFund = new InvestFund(this.newFundName, this.newFundLabel, 0, this.newFundCnpj);
    if(this.allAvailableFundsCtrl.value){
      newFund = this.allAvailableFundsCtrl.value;
    }

    var cnpjUrl = this.getUrlCNPJ(newFund.cnpj);
    this.service.getInvestsSuno(cnpjUrl).subscribe(data => {
      this.retrieveDataFromJson(this.selectedYear, data, newFund.returns, newFund.label);
    });


    this.funds.push(newFund);
    this.allAvailableFundsCtrl.setValue("");
  }

  private getUrlCNPJ(fundCnpj : string) : string {
    var cnpj = String(fundCnpj);
    if(cnpj)
      return cnpj.substring(0,2) + '.' + cnpj.substring(2,5) + '.' + cnpj.substring(5,8) + '%2F' + cnpj.substring(8,12) + '-' + cnpj.substring(12,14);
    else 
      return ""
  } 

}
